import { CurrencyEnum } from '@systemeio/ui'
import { getCssRgbValue } from 'shared/utils/get-css-rgb-value'

const getAffiliateChartColors = () => {
  return {
    currency_blue: getCssRgbValue('--brand-primary'),
    currency_green: getCssRgbValue('--rgb-color-green'),
    currency_yellow: getCssRgbValue('--rgb-color-yellow'),
    currency_red: getCssRgbValue('--rgb-color-red'),
  }
}

export const getAffiliateChartColor = (currency: CurrencyEnum, allCurrencies: CurrencyEnum[]) => {
  const colors = getAffiliateChartColors()

  const currencyColors = Object.values(colors)

  allCurrencies.forEach(cur => {
    switch (cur) {
      case CurrencyEnum.EURO: {
        currencyColors.splice(currencyColors.indexOf(colors.currency_blue), 1)
        break
      }
      case CurrencyEnum.US_DOLLAR: {
        currencyColors.splice(currencyColors.indexOf(colors.currency_green), 1)
        break
      }
      case CurrencyEnum.BRAZILIAN_REAL: {
        currencyColors.splice(currencyColors.indexOf(colors.currency_red), 1)
        break
      }
    }
  })
  switch (currency) {
    case CurrencyEnum.EURO: {
      return colors.currency_blue
    }
    case CurrencyEnum.US_DOLLAR: {
      return colors.currency_green
    }
    case CurrencyEnum.BRAZILIAN_REAL: {
      return colors.currency_red
    }
    default: {
      const currencyIndex = allCurrencies.indexOf(currency)
      const colorIndex = Math.floor(Number(`0.${currencyIndex}`) * currencyColors.length)
      return currencyColors[colorIndex]
    }
  }
}

export const getAffiliateChartTextColor = (
  currency: CurrencyEnum,
  allCurrencies: CurrencyEnum[],
) => {
  const colors = getAffiliateChartColors()

  switch (getAffiliateChartColor(currency, allCurrencies)) {
    case colors.currency_blue: {
      return { color: colors.currency_blue }
    }
    case colors.currency_green: {
      return { color: colors.currency_green }
    }
    case colors.currency_red: {
      return { color: colors.currency_red }
    }
    case colors.currency_yellow: {
      return { color: colors.currency_yellow }
    }
  }
}
